/**
 * @description 全局请求拦截器 - 用于监听所有网络请求
 * @author Cursor
 * @date 2024-04-19
 */

import { CryptoService } from './crypto';

// write by cursor
/**
 * 创建加密后的Blob数据
 * @param data 原始数据
 * @returns 加密后的Blob
 */
function createEncryptedBlob(data: any): Blob {
  const encryptedData = CryptoService.encrypt(data);
  return new Blob([encryptedData], { type: 'text/plain' });
}

// write by cursor
/**
 * 初始化SendBeacon拦截器
 */
function initSendBeaconInterceptor() {
  const originalSendBeacon = navigator.sendBeacon;
  navigator.sendBeacon = function(url: string, data?: BodyInit | null): boolean {
    if (url.includes('/berry/v1/rpt')) {
      let encryptedData: BodyInit | null = null;
      
      if (data) {
        try {
          if (data instanceof Blob) {
            // 读取Blob数据
            const reader = new FileReader();
            reader.onload = function() {
              try {
                const jsonPayload = JSON.parse(reader.result as string);
                // 创建加密后的Blob
                encryptedData = createEncryptedBlob(jsonPayload);
                // 使用加密后的数据发送请求
                originalSendBeacon.call(navigator, url, encryptedData);
              } catch (e) {
                // 如果解析失败，仍然加密原始字符串
                encryptedData = createEncryptedBlob(reader.result);
                originalSendBeacon.call(navigator, url, encryptedData);
              }
            };
            reader.readAsText(data);
            console.groupEnd();
            return true; // 由于异步处理，这里返回true
          } else if (typeof data === 'string') {
            try {
              const jsonPayload = JSON.parse(data);
              // 加密JSON数据
              encryptedData = CryptoService.encrypt(jsonPayload);
            } catch (e) {
              // 如果解析失败，直接加密字符串
              encryptedData = CryptoService.encrypt(data);
            }
          } else {
            // 其他类型数据直接加密
            encryptedData = CryptoService.encrypt(data);
          }
        } catch (error) {
          console.error('payload error:', error);
          encryptedData = data; // 出错时使用原始数据
        }
      }
      
      console.groupEnd();
      return originalSendBeacon.call(navigator, url, encryptedData);
    }
    
    return originalSendBeacon.call(navigator, url, data);
  };
}

// write by cursor
/**
 * 初始化全局请求拦截器
 */
export function initializeRequestInterceptor() {
  // 初始化 SendBeacon 拦截器
  initSendBeaconInterceptor();
  
  console.log('global request interceptor initialized');
} 